import Chart from "../../../../src/client/katnh/interactions/chart/Chart.js";
import Longembolie from "../../../../src/client/katnh/verdenking-op-longembolie.json";
import * as React from 'react';
export default {
  Chart,
  Longembolie,
  React
};